import React, { useEffect } from 'react';
import {connect, useSelector} from "react-redux";

// components
import {showLoader} from "../../../components/loader/loader";

// actions
import {getStateByPath} from "../../../redux/selectors";
import {ADD_STATE, REMOVE_STATE} from "../../../redux/actions/generics/IndexedActions";
import RoleList from "./_list";

function User(props) {
    const path = props.path || 'security/role';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    return (
        <>
            {loading && showLoader()}
            { componentState && <RoleList path={path} /> }
        </>
    );
}

const mapStateToProps = _ => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
});

export default connect(mapStateToProps, mapActionsToProps)(User)